import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as listsActions from '../../store/lists/actions';
import * as adsActions from '../../store/ads/actions';
import * as reducers from '../../store/reducers';

import ContentCollections from 'Containers/ContentCollections';
import Hero from 'Containers/Hero';
import RampUnit from '../../utils/Playwire/RampUnit';
import Loading from 'Components/Loading';
import DocumentHeadFields from 'Components/DocumentHeadFields';
import VideoSiderailPlayer from 'Components/VideoSiderailPlayer';
import ErrorPage from 'Screens/ErrorPage';
import AdditionalMaterials from 'Components/AdditionalMaterials';

import { withLocationWrapper } from '../../utils/HOC_LocationWrapper';

import {
  HARRY_MOON_LANDING_HERO,
  HARRY_MOON_SERIES_HERO,
  HARRY_MOON_MEDIA_TYPE,
  PARTNERSHIPS_AND_RESOURCES,
} from './constants';

class HarryMoonLandingPage extends Component {
  constructor(props) {
    super(props);
    this.onAdLoad = this.onAdLoad.bind(this);
    this.onAdClick = this.onAdClick.bind(this);
  }

  componentDidMount() {
    this.fetchData();
  }

  onAdLoad() {
    const { trackAdInternal, harryMoonLandingHero } = this.props;
    if (harryMoonLandingHero)
      trackAdInternal(
        HARRY_MOON_LANDING_HERO,
        'AD_VIEWED',
        harryMoonLandingHero
      );
  }

  onAdClick(eventId, elementId) {
    const { trackAdInternal, harryMoonLandingHero } = this.props;
    if (harryMoonLandingHero)
      trackAdInternal(
        HARRY_MOON_LANDING_HERO,
        eventId,
        harryMoonLandingHero,
        elementId
      );
  }

  fetchData() {
    const { fetchMediaLists, location } = this.props;
    const qs = {};
    fetchMediaLists(HARRY_MOON_MEDIA_TYPE, location.pathname, qs);
  }

  render() {
    const {
      isFetching,
      errors,
      lists,
      harryMoonLandingHero,
      harryMoonSeriesHero,
    } = this.props;

    if (errors.lists && !lists) {
      return (
        <ErrorPage
          errorCode="500"
          errorType="unknownError"
          errorMessage={errors.lists.message}
        />
      );
    }

    if (isFetching) {
      return <Loading />;
    }

    const bookList = lists && [lists[0]];
    const { items: supplementalMaterials } = lists ? lists[1] : {};

    return (
      <main>
        <DocumentHeadFields documentTitle="Harry Moon Series" />
        <div className="Page__container Page__container--no-padding">
          <RampUnit type="leaderboard_atf" id="top" />
        </div>
        <div className="Page__ContentWrapper">
          <div className="Page__container Page__container--split-layout Page__container--main">
            {harryMoonLandingHero && (
              <Hero
                hero={harryMoonLandingHero}
                heroType="media"
                className="GradeHeader__hero"
              />
            )}
            <section className="ContentBlock">
              <div className="ContentBlock__content">
                <div>
                  <ContentCollections lists={bookList} />
                </div>
                {harryMoonSeriesHero && (
                  <div>
                    <Hero
                      heroType="media"
                      hero={{
                        ...harryMoonSeriesHero,
                        buttons: [harryMoonSeriesHero.buttons[1]],
                      }}
                    />
                  </div>
                )}
                <div>
                  {supplementalMaterials && (
                    <AdditionalMaterials
                      title="Resources to get your class talking about Harry Moon!"
                      items={supplementalMaterials.map(
                        ({
                          title,
                          description,
                          attachments: [{ url, thumbnails }],
                        }) => ({
                          title,
                          description,
                          url,
                          imageUrl: thumbnails.large.url,
                        })
                      )}
                    />
                  )}
                </div>
                <div>
                  <AdditionalMaterials
                    title="Partnerships & Resources"
                    description="Reading has been proven to enhance children’s development in a variety of different ways. However, many children do not have access to the reading experiences they need or deserve. Several organizations aim to enhance literacy engagement by providing children with a library of their own. Group activities have also been proven to promote deeper engagement. Check out these resources to see how to enhance your students’ reading experiences!"
                    items={PARTNERSHIPS_AND_RESOURCES}
                  />
                </div>
              </div>

              <aside className="ContentBlock__aside">
                <VideoSiderailPlayer />
                <RampUnit type="med_rect_atf" id="siderec" />
                <RampUnit type="med_rect_btf" id="sideflex" />
              </aside>
            </section>
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state, { location }) => {
  return {
    isFetching: reducers.getIsPageFetching(state),
    harryMoonLandingHero: reducers.getAdCampaign(
      state,
      HARRY_MOON_LANDING_HERO
    ),
    harryMoonSeriesHero: reducers.getAdCampaign(state, HARRY_MOON_SERIES_HERO),
    lists: reducers.getMediaLists(
      state,
      HARRY_MOON_MEDIA_TYPE,
      location.pathname
    ),
    errors: reducers.getErrors(state),
  };
};

const HarryMoonLandingPageComponent =  connect(mapStateToProps, { ...listsActions, ...adsActions })(HarryMoonLandingPage);

export default withLocationWrapper(HarryMoonLandingPageComponent);
